import { render, staticRenderFns } from "./StaticInfosAdd.vue?vue&type=template&id=16fe3784&scoped=true&"
import script from "./StaticInfosAdd.vue?vue&type=script&lang=js&"
export * from "./StaticInfosAdd.vue?vue&type=script&lang=js&"
import style0 from "./StaticInfosAdd.vue?vue&type=style&index=0&id=16fe3784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fe3784",
  null
  
)

export default component.exports